module.exports = __webpack_public_path__ + "static/media/13.13ec00bc.jpg";